export default __webpack_public_path__ + "static/media/successLogo.04ac21e3.svg";